<template>
    <div class="guide-container">
        <!-- 激活支付模块 -->
        <div class="feature-card activate-card">
            <div class="feature-content">
                <h2 class="feature-title">{{ $t('message.guide.activatePayouts') }}</h2>
                <p class="feature-desc">
                    {{ $t('message.guide.provide1') }} <span class="highlight">{{ $t('message.guide.provide2') }}</span> {{ $t('message.guide.provide3') }}
                    <span class="highlight">{{ $t('message.guide.provide4') }}</span>.
                </p>
                <el-button type="primary" class="activate-btn" @click="activatePayouts">{{ $t('message.guide.activateBtn') }}</el-button>
            </div>
        </div>

        <!-- 功能特点列表 -->
        <div class="features-list">
            <!-- 快速结算 -->
            <div class="feature-item" >
                <div class="feature-left">
                    <div class="feature-icon-wrapper">
                        <div class="feature-icon fast-icon">
                            <img src="@/assets/images/guide1.png" alt="">
                        </div>
                    </div>
                    <div class="feature-detail">
                        <h3 class="feature-item-title">{{ $t('message.guide.info1Title') }}</h3>
                        <p class="feature-item-desc" v-html="$t('message.guide.info1Desc')">
                        </p>
                    </div>
                </div>
                <div class="feature-right">
                    <div class="image-placeholder fast-settlement-img">
                        <img src="@/assets/images/guider1.png" alt="">
                    </div>
                </div>
            </div>

            <!-- 多币种支持 -->
            <div class="feature-item">
                <div class="feature-left">
                    <div class="feature-icon-wrapper">
                        <div class="feature-icon currency-icon">
                            <img src="@/assets/images/guide2.png" alt="">
                        </div>
                    </div>
                    <div class="feature-detail">
                        <h3 class="feature-item-title">{{ $t('message.guide.info2Title') }}</h3>
                        <p class="feature-item-desc" v-html="$t('message.guide.info2Desc')">
                        </p>
                    </div>
                </div>
                <div class="feature-right">
                    <div class="image-placeholder currency-flags">
                        <img src="@/assets/images/guider2.png" alt="">
                    </div>
                </div>
            </div>

            <!-- 实时汇率 -->
            <div class="feature-item">
                <div class="feature-left">
                    <div class="feature-icon-wrapper">
                        <div class="feature-icon exchange-icon">
                            <img src="@/assets/images/guide3.png" alt="快速结算">

                        </div>
                    </div>
                    <div class="feature-detail">
                        <h3 class="feature-item-title">{{ $t('message.guide.info3Title') }}</h3>
                        <p class="feature-item-desc" v-html="$t('message.guide.info3Desc')">
                        </p>
                    </div>
                </div>
                <div class="feature-right">
                    <div class="image-placeholder exchange-rate">
                        <img src="@/assets/images/guider3.png" alt="">
                    </div>
                </div>
            </div>

            <!-- 安全可靠 -->
            <div class="feature-item">
                <div class="feature-left">
                    <div class="feature-icon-wrapper">
                        <div class="feature-icon security-icon">
                            <img src="@/assets/images/guide4.png" alt="快速结算">
                        </div>
                    </div>
                    <div class="feature-detail">
                        <h3 class="feature-item-title">{{ $t('message.guide.info4Title') }}</h3>
                        <p class="feature-item-desc" v-html="$t('message.guide.info4Desc')">
                        </p>
                    </div>
                </div>
                <div class="feature-right">
                    <div class="image-placeholder security-img">
                        <!-- 图片占位符 - 安全可靠 -->
                        <img src="@/assets/images/guider4.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Guide',
    data() {
        return {};
    },
    methods: {
        activatePayouts() {
            this.$router.push({ path: '/account/supplement/payout', query: { isFastPayout: true } });
        },
    },
};
</script>

<style lang="scss" scoped>
.guide-container {
    padding: 30px;
    box-sizing: border-box;
    // max-width: 1200px;
    margin: 0 auto;
    // font-family: Arial, sans-serif;
    color: #333;
}

// 激活支付卡片样式
.feature-card {
    border-radius: 16px;
    padding: 30px;
    margin-bottom: 40px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    &.activate-card {
        background-color: #f5f9ff;
        position: relative;
        overflow: hidden;
        background-image: url('~@/assets/images/bg.png');
        // background-size: 100% 100%;
        background-position: right;
        background-repeat: no-repeat;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
            z-index: 1;
        }

        .feature-content {
            position: relative;
            z-index: 2;
        }
    }
}

.feature-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
}

.feature-desc {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 24px;
    color: #666;
}

.highlight {
    color: #00A2DD;
    font-weight: 500;
}

.activate-btn {
    background-color: #00A2DD;
    border-color: #00A2DD;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;

    &:hover {
        background-color: #40a9ff;
        border-color: #40a9ff;
    }
}

// 功能列表样式
.features-list {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.feature-item {
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #F2F3F5;
    position: relative;
    overflow: hidden;
}

.feature-left {
    display: flex;
    width: 50%;
    padding-right: 20px;
    align-items: center;
}

.feature-right {
    width: 50%;
    display: flex;
    justify-content: left;
    align-items: center;
}

.feature-icon-wrapper {
    margin-right: 16px;
    flex-shrink: 0;
}

.feature-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
   img{
    width: 100%;
    height: 100%;
   }
    &.fast-icon {
       // background-color: #f0f7ff;

        i {
            color: #1890ff;
        }
    }

    &.currency-icon {
        // background-color: #f6f5ff;

        i {
            color: #722ed1;
        }
    }

    &.exchange-icon {
        // background-color: #f4f8ff;

        i {
            color: #2f54eb;
        }
    }

    &.security-icon {
        // background-color: #f6ffed;

        i {
            color: #52c41a;
        }
    }

    i {
        font-size: 24px;
    }
}

.feature-detail {
    flex: 1;
}

.feature-item-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.feature-item-desc {
    font-size: 14px;
    line-height: 1.5;
    color: #666;
    margin: 0;
}

// 图片占位符样式
.image-placeholder {
    width: 100%;
    // height: 180px;
    // background-color: #f5f7fa;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: left;
    overflow: hidden;

}

// 快速结算图片样式
.fast-settlement-img {
    // background-color: #6c8cff;
    // width: 290px;
    height: 250px;
    object-fit: cover;
    border-bottom-left-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
    img{
        object-fit: cover;
        height: 100%;
    }
}

// 多币种支持图片样式
.currency-flags {
    // background-color: #f9f9f9;
    // width: 290px;
    height: 120px;
    object-fit: cover;
    img{
        // width: 100%;
        object-fit: cover;
        height: 100%;
    }
}

// 实时汇率图片样式
.exchange-rate {
    // background-color: #f0f7ff;
    width: 434px;
    object-fit: cover;
    img{
        width: 100%;
        object-fit: cover;
    }

}

// 安全可靠图片样式
.security-img {
    // width: 368px;
    height: 200px;
    object-fit: cover;
    img{
        // width: 100%;
        object-fit: cover;
        height: 100%;
    }
    // background-color: #f6ffed;
}

// 响应式布局
@media (max-width: 768px) {
    .feature-item {
        flex-direction: column;
    }

    .feature-left,
    .feature-right {
        width: 100%;
    }

    .feature-right {
        margin-top: 20px;
    }
}
</style>
